// // // // // // // Default // // // // // // //
export const Chloe_Tamaki = {
  Dear_Idle: require("../assets/credits/default/School_Festival_Chloe_Cafe_Tamaki_Dear_Idle.gif"),
  Dear_Smile: require("../assets/credits/default/School_Festival_Chloe_Cafe_Tamaki_Dear_Smile.gif"),
  Friend_HighTouch: require("../assets/credits/default/School_Festival_Chloe_Cafe_Tamaki_Friend_HighTouch.gif"),
};

export const Kaori_Kasumi = {
  Dear_Idle: require("../assets/credits/default/Default_Kaori_Kasumi_Dear_Idle.gif"),
  Dear_Smile: require("../assets/credits/default/Default_Kaori_Kasumi_Dear_Smile.gif"),
  Friend_HighTouch: require("../assets/credits/default/Default_Kaori_Kasumi_Friend_HighTouch.gif"),
};

export const Ninon_Kokkoro = {
  Dear_Idle: require("../assets/credits/default/Oedo_Ninon_Ranger_Kokkoro_Dear_Idle.gif"),
  Dear_Smile: require("../assets/credits/default/Oedo_Ninon_Ranger_Kokkoro_Dear_Smile.gif"),
  Friend_HighTouch: require("../assets/credits/default/Oedo_Ninon_Ranger_Kokkoro_Friend_HighTouch.gif"),
};

export const Ruka_Saren = {
  Dear_Idle: require("../assets/credits/default/Sarasalia_Ruka_Saren_Dear_Idle.gif"),
  Dear_Smile: require("../assets/credits/default/Sarasalia_Ruka_Saren_Dear_Smile.gif"),
  Friend_HighTouch: require("../assets/credits/default/Sarasalia_Ruka_Saren_Friend_HighTouch.gif"),
};

export const Suzuna_Kyaru = {
  Dear_Idle: require("../assets/credits/default/Student_Suzuna_Kyaru_Dear_Idle.gif"),
  Dear_Smile: require("../assets/credits/default/Student_Suzuna_Kyaru_Dear_Smile.gif"),
  Friend_HighTouch: require("../assets/credits/default/Student_Suzuna_Kyaru_Friend_HighTouch.gif"),
};


// // // // // // // New Year // // // // // // //
export const New_Year_Hiyori_Rei = {
  Dear_Idle: require("../assets/credits/new_year/New_Year_Hiyori_Rei_Dear_Idle.gif"),
  Dear_Smile: require("../assets/credits/new_year/New_Year_Hiyori_Rei_Dear_Smile.gif"),
  Friend_HighTouch: require("../assets/credits/new_year/New_Year_Hiyori_Rei_Friend_HighTouch.gif"),
};


// // // // // // // Summer // // // // // // //
export const Summer_Akino_Saren = {
  Dear_Idle: require("../assets/credits/summer/Summer_Akino_Saren_Dear_Idle.gif"),
  Dear_Smile: require("../assets/credits/summer/Summer_Akino_Saren_Dear_Smile.gif"),
  Friend_HighTouch: require("../assets/credits/summer/Summer_Akino_Saren_Friend_HighTouch.gif"),
};

export const Summer_Kaori_Kasumi = {
  Dear_Idle: require("../assets/credits/summer/Summer_Kaori_Kasumi_Dear_Idle.gif"),
  Dear_Smile: require("../assets/credits/summer/Summer_Kaori_Kasumi_Dear_Smile.gif"),
  Friend_HighTouch: require("../assets/credits/summer/Summer_Kaori_Kasumi_Friend_HighTouch.gif"),
};

export const Summer_Nozomi_Suzuna = {
  Dear_Idle: require("../assets/credits/summer/Summer_Nozomi_Suzuna_Dear_Idle.gif"),
  Dear_Smile: require("../assets/credits/summer/Summer_Nozomi_Suzuna_Dear_Smile.gif"),
  Friend_HighTouch: require("../assets/credits/summer/Summer_Nozomi_Suzuna_Friend_HighTouch.gif"),
};

export const Summer_Ruka_Rei = {
  Dear_Idle: require("../assets/credits/summer/Summer_Ruka_Rei_Dear_Idle.gif"),
  Dear_Smile: require("../assets/credits/summer/Summer_Ruka_Rei_Dear_Smile.gif"),
  Friend_HighTouch: require("../assets/credits/summer/Summer_Ruka_Rei_Friend_HighTouch.gif"),
};

export const Summer_Tsumugi_Tamaki = {
  Dear_Idle: require("../assets/credits/summer/Summer_Tsumugi_Tamaki_Dear_Idle.gif"),
  Dear_Smile: require("../assets/credits/summer/Summer_Tsumugi_Tamaki_Dear_Smile.gif"),
  Friend_HighTouch: require("../assets/credits/summer/Summer_Tsumugi_Tamaki_Friend_HighTouch.gif"),
};


// // // // // // // Halloween // // // // // // //
export const Halloween_Ninon_Suzuna = {
  Dear_Idle: require("../assets/credits/halloween/Halloween_Ninon_Suzuna_Dear_Idle.gif"),
  Dear_Smile: require("../assets/credits/halloween/Halloween_Ninon_Suzuna_Dear_Smile.gif"),
  Friend_HighTouch: require("../assets/credits/halloween/Halloween_Ninon_Suzuna_Friend_HighTouch.gif"),
};


// // // // // // // Christmas // // // // // // //
export const Christmas_Akari_Yori = {
  Dear_Idle: require("../assets/credits/christmas/Christmas_Akari_Yori_Dear_Idle.gif"),
  Dear_Smile: require("../assets/credits/christmas/Christmas_Akari_Yori_Dear_Smile.gif"),
  Friend_HighTouch: require("../assets/credits/christmas/Christmas_Akari_Yori_Friend_HighTouch.gif"),
};
